import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesGridSection() {
  return (
    <section id="artykuly" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-4">
          Poradniki i artykuły Kakobuy Spreadsheet
        </h2>
        <div className="flex justify-center mb-4">
          <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
        </div>
        <p className="text-sm md:text-base text-foreground-600 text-center max-w-2xl mx-auto mb-12 leading-relaxed">
          Pogłębiaj swoją wiedzę o Kakobuy Spreadsheet. Przeczytaj nasze szczegółowe poradniki,
          rankingi produktów, porównania platform i analizy bezpieczeństwa zakupów.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-300/60 transition-all cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/9] w-full overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.h1Title}
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.h1Title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center text-accent-600 text-sm font-medium whitespace-nowrap mt-auto">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line ml-1.5 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Otwórz pełny Kakobuy Spreadsheet
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}